// Client-side mirror of backend unit conversions for instant previews.
const WEIGHT_TO_G = { oz: 28.349523125, lb: 453.59237, grams: 1.0, g: 1.0 };
const VOLUME_TO_ML = { ml: 1.0, "fl oz": 29.5735295625, tbsp: 14.78676478 };
const COUNT_UNITS = ["count"];

export function unitDim(unit) {
  if (!unit) return null;
  const u = unit.toLowerCase();
  if (WEIGHT_TO_G[u]) return "weight";
  if (VOLUME_TO_ML[u]) return "volume";
  if (COUNT_UNITS.includes(u)) return "count";
  if (u === "servings") return "servings";
  return null;
}

export function servingCost(amount, unit, price, pkgQty, pkgUnit, servingsOnPackage) {
  amount = parseFloat(amount);
  price = parseFloat(price);
  pkgQty = parseFloat(pkgQty);
  if (isNaN(amount) || isNaN(price) || isNaN(pkgQty) || pkgQty === 0) return null;
  const sd = unitDim(unit);
  const pd = unitDim(pkgUnit);
  if (unit === "servings") {
    if (servingsOnPackage) return (price * amount) / servingsOnPackage;
    return null;
  }
  if (sd === "weight" && pd === "weight")
    return (price * (amount * WEIGHT_TO_G[unit.toLowerCase()])) / (pkgQty * WEIGHT_TO_G[pkgUnit.toLowerCase()]);
  if (sd === "volume" && pd === "volume")
    return (price * (amount * VOLUME_TO_ML[unit.toLowerCase()])) / (pkgQty * VOLUME_TO_ML[pkgUnit.toLowerCase()]);
  if (sd === "count" && pd === "count") return (price * amount) / pkgQty;
  return null;
}

export function unitCosts(price, pkgQty, pkgUnit, servingsOnPackage) {
  price = parseFloat(price);
  pkgQty = parseFloat(pkgQty);
  const out = {};
  if (isNaN(price) || isNaN(pkgQty) || pkgQty === 0) return out;
  const d = unitDim(pkgUnit);
  if (d === "weight") {
    const grams = pkgQty * WEIGHT_TO_G[pkgUnit.toLowerCase()];
    out.cost_per_gram = price / grams;
    out.cost_per_oz = (price / grams) * WEIGHT_TO_G.oz;
  } else if (d === "volume") {
    const ml = pkgQty * VOLUME_TO_ML[pkgUnit.toLowerCase()];
    out.cost_per_ml = price / ml;
    out.cost_per_fl_oz = (price / ml) * VOLUME_TO_ML["fl oz"];
  } else if (d === "count") {
    out.cost_per_item = price / pkgQty;
  }
  if (servingsOnPackage) out.cost_per_mfg_serving = price / servingsOnPackage;
  return out;
}
